export default "/images/5454b49469234f7efb3a308b48c0f890.avif";